/**
 * Studio → Prompts (parent layout) — outlets the index + detail routes
 * underneath `/studio/prompts`.
 *
 * Pre-refactor this file mounted `<PromptEditor scope="tenant" />`
 * directly, which made `/studio/prompts/:id` impossible because the
 * child detail route had nowhere to render.
 *
 * Closes #153 (Studio: replace Skills + Prompts sheet editors with full
 * detail pages). The list lives in `prompts.index.tsx`; the detail page
 * in `prompts.$promptId.tsx`. The Sheet create flow on the list remains
 * for quick authoring — the detail page is the full edit surface
 * (Identity / Template / Variables / Preview / Used by).
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/prompts')({
  component: StudioPromptsLayout,
});

function StudioPromptsLayout() {
  return <Outlet />;
}
